import { t } from "../i18n"
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiCommentController from "./ai_comment_controller"
application.register("ai-comment", AiCommentController)

import AiCopilotController from "./ai_copilot_controller"
application.register("ai-copilot", AiCopilotController)

import AssemblyEditorController from "./assembly_editor_controller"
application.register("assembly-editor", AssemblyEditorController)

import AssetFormController from "./asset_form_controller"
application.register("asset-form", AssetFormController)

import AssetMediaUploadController from "./asset_media_upload_controller"
application.register("asset-media-upload", AssetMediaUploadController)

import AssetNormalizationController from "./asset_normalization_controller"
application.register("asset-normalization", AssetNormalizationController)

import AssetTagGenerationController from "./asset_tag_generation_controller"
application.register("asset-tag-generation", AssetTagGenerationController)

import AssetTemplateController from "./asset_template_controller"
application.register("asset-template", AssetTemplateController)

import AssignClickController from "./assign_click_controller"
application.register("assign-click", AssignClickController)

import AttachmentRemovalController from "./attachment_removal_controller"
application.register("attachment-removal", AttachmentRemovalController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import CalendarModalController from "./calendar_modal_controller"
application.register("calendar-modal", CalendarModalController)

import CalendarUserFilterController from "./calendar_user_filter_controller"
application.register("calendar-user-filter", CalendarUserFilterController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import ChecklistBuilderController from "./checklist_builder_controller"
application.register("checklist-builder", ChecklistBuilderController)

import ChecklistCompletionController from "./checklist_completion_controller"
application.register("checklist-completion", ChecklistCompletionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompanySwitcherController from "./company_switcher_controller"
application.register("company-switcher", CompanySwitcherController)

import ComplianceUploadController from "./compliance_upload_controller"
application.register("compliance-upload", ComplianceUploadController)

import DashboardChartController from "./dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import DocxViewerController from "./docx_viewer_controller"
application.register("docx-viewer", DocxViewerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExtraValuesController from "./extra_values_controller"
application.register("extra-values", ExtraValuesController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileUploadSpinnerController from "./file_upload_spinner_controller"
application.register("file-upload-spinner", FileUploadSpinnerController)

import FormSubmissionController from "./form_submission_controller"
application.register("form-submission", FormSubmissionController)

import GeofenceDrawController from "./geofence_draw_controller"
application.register("geofence-draw", GeofenceDrawController)

import GeofencePreviewController from "./geofence_preview_controller"
application.register("geofence-preview", GeofencePreviewController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HexMapController from "./hex_map_controller"
application.register("hex-map", HexMapController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import IotSparklineController from "./iot_sparkline_controller"
application.register("iot-sparkline", IotSparklineController)

import JsonChecklistEditorController from "./json_checklist_editor_controller"
application.register("json-checklist-editor", JsonChecklistEditorController)

import LexicalEditorController from "./lexical_editor_controller"
application.register("lexical-editor", LexicalEditorController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MaintRuleTriggerController from "./maint_rule_trigger_controller"
application.register("maint-rule-trigger", MaintRuleTriggerController)

import MaintenanceController from "./maintenance_controller"
application.register("maintenance", MaintenanceController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalCloserController from "./modal_closer_controller"
application.register("modal-closer", ModalCloserController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavSectionController from "./nav_section_controller"
application.register("nav-section", NavSectionController)

import OfflineFormController from "./offline_form_controller"
application.register("offline-form", OfflineFormController)

import OfflineUploadController from "./offline_upload_controller"
application.register("offline-upload", OfflineUploadController)

import OnboardingSelectionController from "./onboarding_selection_controller"
application.register("onboarding-selection", OnboardingSelectionController)

import ParallelUploadController from "./parallel_upload_controller"
application.register("parallel-upload", ParallelUploadController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import RoiCalculatorController from "./roi_calculator_controller"
application.register("roi-calculator", RoiCalculatorController)

import ScanIntelligenceController from "./scan_intelligence_controller"
application.register("scan-intelligence", ScanIntelligenceController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SmartTemplateController from "./smart_template_controller"
application.register("smart-template", SmartTemplateController)

import SmartTimeEstimateController from "./smart_time_estimate_controller"
application.register("smart-time-estimate", SmartTimeEstimateController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import SyncController from "./sync_controller"
application.register("sync", SyncController)

import TagDeliverySelectionController from "./tag_delivery_selection_controller"
application.register("tag-delivery-selection", TagDeliverySelectionController)

import TagSelectionController from "./tag_selection_controller"
application.register("tag-selection", TagSelectionController)

import TaskAssigneeController from "./task_assignee_controller"
application.register("task-assignee", TaskAssigneeController)

import TaskChecklistController from "./task_checklist_controller"
application.register("task-checklist", TaskChecklistController)

import TeamMembersController from "./team_members_controller"
application.register("team-members", TeamMembersController)

import TrackerMapController from "./tracker_map_controller"
application.register("tracker-map", TrackerMapController)

import TrixAttachController from "./trix_attach_controller"
application.register("trix-attach", TrixAttachController)

import TrixContentController from "./trix_content_controller"
application.register("trix-content", TrixContentController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import UpgradePlanModalController from "./upgrade_plan_modal_controller"
application.register("upgrade-plan-modal", UpgradePlanModalController)

import VoiceDictationController from "./voice_dictation_controller"
application.register("voice-dictation", VoiceDictationController)

import WebhookHeaderRowController from "./webhook_header_row_controller"
application.register("webhook-header-row", WebhookHeaderRowController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import WorkflowController from "./workflow_controller"
application.register("workflow", WorkflowController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)
